import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SharedAvatar from '../../shared/avatar';

const desktopSize = {
  xs: 40,
  sm: 50,
};

const mobileSize = {
  xs: 38,
  sm: 50,
};

const Container = styled.div`
  & > a {
    display: inline-block;
    height: ${props => (props.theme.isMobile ? mobileSize[props.size] : desktopSize[props.size])}px;
  }

  & > a > img {
    margin-right: 12px;

    ${props => (props.theme.isMobile ? `
      height: ${mobileSize[props.size]}px;
      width: ${mobileSize[props.size]}px;
    ` : `
      height: ${desktopSize[props.size]}px;
      width: ${desktopSize[props.size]}px;
    `)};
  }
`;

export default function Avatar({ profile, size }) {
  return (
    <Container size={size}>
      <SharedAvatar {...profile} />
    </Container>
  );
}

Avatar.propTypes = {
  profile: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    profilePictureUrl: PropTypes.string,
    contributorOrEditor: PropTypes.bool.isRequired,
  }).isRequired,
  size: PropTypes.oneOf(['xs', 'sm']).isRequired,
};
